import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

export interface AssistantNotJoinedProps {
  reason: string | null
}

export const AssistantNotJoined: React.FC<AssistantNotJoinedProps> = ({ reason }) => {
  return (
    <Container>
      <Row>
        <Col className='d-flex justify-content-center text-center'>
          {reason
            ? reason
            : 'Assistant was not admitted to join the meeting from the waiting room therefore we could not generate any meeting summary or AI results.'}
        </Col>
      </Row>
    </Container>
  )
}
